$('document').ready(() => {
    const filters = $('.filters');

    $('.page-catalog__mob-filters-btn').click(() => {
        filters.addClass('filters--open');
        bodyFixPosition();
    });
    $('.filters__mob-top-back').click(() => {
        filters.removeClass('filters--open');
        bodyUnfixPosition();
    });
    $('.filters__mob-top-close').click(() => {
        filters.removeClass('filters--open');
        bodyUnfixPosition();
    });

    if (filters.length) {
        window.addEventListener('resize', () => {
            if (window.innerWidth <= 767) {
                if (filters.hasClass('filters--open')) {
                    filters.addClass('filters--open');
                    bodyFixPosition();
                }
            } else {
                if (filters.hasClass('filters--open')) {
                    filters.removeClass('filters--open');
                    bodyUnfixPosition();
                }
            }
        })
    }
})
